/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Art_1_StateInputs */

const en_svc_agents_art_1_state = /** @type {(inputs: Svc_Agents_Art_1_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read`)
};

const lv_svc_agents_art_1_state = /** @type {(inputs: Svc_Agents_Art_1_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nolasīts`)
};

/**
* | output |
* | --- |
* | "Read" |
*
* @param {Svc_Agents_Art_1_StateInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_art_1_state = /** @type {((inputs?: Svc_Agents_Art_1_StateInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Art_1_StateInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_art_1_state(inputs)
	return en_svc_agents_art_1_state(inputs)
});